// Carte des hubs (pages à onglets) + anciennes URL → nouvelle destination. Données pures (aucun composant) pour éviter les cycles d'import.
export const HUB_META = {
  "/app/studio-creatif": { title: "Studio créatif", desc: "Visuels, affiches, logos et contenus IA", tabs: [
    { key: "contenu", label: "Studio Contenu (IA)", legacy: "/app/studio-contenu" },
    { key: "impact", label: "Impact Studio", legacy: "/app/impact-studio" },
    { key: "ia", label: "Studio IA", legacy: "/app/studio-ia" },
    { key: "affiches", label: "Affiches", legacy: "/app/generateur-affiches" },
    { key: "logos", label: "Logos & marque", legacy: "/app/logos" },
  ] },
  "/app/publications": { title: "Publications & réseaux", desc: "Facebook, Instagram, TikTok et pilote automatique", tabs: [
    { key: "marketing", label: "Publications", legacy: "/app/marketing" },
    { key: "studio", label: "Marketing Studio", legacy: "/app/marketing-studio" },
    { key: "autopilote", label: "Pilote auto", legacy: "/app/pilote-reseaux" },
    { key: "facebook", label: "Facebook", legacy: "/app/facebook" },
    { key: "tiktok", label: "TikTok", legacy: "/app/tiktok" },
    { key: "pipeline", label: "Pipeline IA", legacy: "/app/studio" },
  ] },
  "/app/campagnes": { title: "Campagnes", desc: "Plan annuel, campagnes et tableau de bord marketing", tabs: [
    { key: "planificateur", label: "Planificateur annuel", legacy: "/app/planificateur-annuel" },
    { key: "les3", label: "Campagne « Les 3 »", legacy: "/app/campagne-les3" },
    { key: "plan30", label: "Checklist 30 jours", legacy: "/app/marketing-plan30" },
    { key: "tableau", label: "Tableau Marketing", legacy: "/app/marketing-dashboard" },
    { key: "ai", label: "Marketing AI", legacy: "/app/marketing-ai" },
  ] },
  "/app/encaissements": { title: "Encaissements & impayés", desc: "Paiements membres, factures, relances, recouvrement", tabs: [
    { key: "membres", label: "Paiements membres", legacy: "/app/membres-paiements" },
    { key: "contrats", label: "Contrats & paiements", legacy: "/app/contrats-paiements" },
    { key: "factures", label: "Factures à payer", legacy: "/app/factures-impayees" },
    { key: "relances", label: "Relances impayés", legacy: "/app/relances-impayes" },
    { key: "recouvrement", label: "Recouvrement", legacy: "/app/recouvrement" },
    { key: "credit", label: "Crédit & récurrents", legacy: "/app/credit" },
  ] },
  "/app/stripe": { title: "Stripe", desc: "Liens de paiement, rapprochement, revenus en ligne", tabs: [
    { key: "liens", label: "Liens de paiement", legacy: "/app/stripe-manager" },
    { key: "rapprochement", label: "Rapprochement", legacy: "/app/stripe-rapprochement" },
    { key: "revenus", label: "Revenus en ligne", legacy: "/app/revenus-en-ligne" },
    { key: "reconciliation", label: "Réconciliation", legacy: "/app/reconciliation" },
  ] },
  "/app/comptabilite-taxes": { title: "Comptabilité & taxes", desc: "Tenue de livres, facturation, TPS/TVQ, QuickBooks", tabs: [
    { key: "comptabilite", label: "Comptabilité", legacy: "/app/comptabilite" },
    { key: "kaizen", label: "Kaizen Comptabilité", legacy: "/app/comptabilite-kaizen" },
    { key: "facturation", label: "Facturation", legacy: "/app/facturation" },
    { key: "tps-tvq", label: "Rapprochement TPS/TVQ", legacy: "/app/rapprochement-tps-tvq" },
    { key: "entites", label: "Séparation revenus", legacy: "/app/separation-revenus" },
    { key: "quickbooks", label: "QuickBooks", legacy: "/app/quickbooks" },
  ] },
  "/app/pilotage-financier": { title: "Pilotage financier", desc: "Finances, P&L, plan revenu, objectifs du mois", tabs: [
    { key: "finances", label: "Finances", legacy: "/app/finances" },
    { key: "pnl", label: "P&L Live", legacy: "/app/pnl" },
    { key: "plan7j", label: "Plan Revenu 7 j", legacy: "/app/revenue-plan" },
    { key: "objectifs", label: "Objectifs du mois", legacy: "/app/objectifs-mois" },
  ] },
  "/app/calendrier": { title: "Agenda & horaires", desc: "Horaire des cours, événements, calendriers", tabs: [
    { key: "horaire", label: "Horaire des cours", legacy: "/app/horaire" },
    { key: "ete", label: "Horaire d'été", legacy: "/app/horaire-ete" },
    { key: "evenements", label: "Événements", legacy: "/app/evenements" },
    { key: "annuel", label: "Calendrier annuel", legacy: "/app/calendrier-annuel" },
    { key: "kaizen", label: "Journées spéciales", legacy: "/app/calendrier-kaizen" },
    { key: "agenda", label: "Agenda unifié", legacy: "/app/agenda" },
  ] },
  "/app/grille-tarifaire": { title: "Tarifs", desc: "Tarifs du dojo, carnets, conformité", tabs: [
    { key: "dojo", label: "Tarifs Dojo", legacy: "/app/inscriptions-dojo" },
    { key: "carnets", label: "Tarifs · Carnets · PK", legacy: "/app/tarifs" },
    { key: "conformite", label: "Conformité & tarifs", legacy: "/app/conformite" },
  ] },
  "/app/assistants-ia": { title: "Assistants IA", desc: "Operator, Wingman, Camille, mémoire", tabs: [
    { key: "operator", label: "AI Operator", legacy: "/app/operator" },
    { key: "wingman", label: "Wingman", legacy: "/app/wingman" },
    { key: "wingman-gmail", label: "Wingman Gmail", legacy: "/app/wingman-gmail" },
    { key: "camille", label: "Camille (réception)", legacy: "/app/camille" },
    { key: "memoire", label: "Mémoire KAIZEN", legacy: "/app/memoire" },
    { key: "recherche", label: "Recherche & veille (Perplexity)", legacy: "/app/recherche" },
    { key: "dossiers", label: "Assistant IA", legacy: "/app/dossiers" },
    { key: "courriels", label: "Courriels IA", legacy: "/app/courriels" },
  ] },
  "/app/communications": { title: "Communications", desc: "Diffusions courriel & SMS, annonces, modèles", tabs: [
    { key: "courriel", label: "Diffusion courriel", legacy: "/app/diffusion-courriel" },
    { key: "sms", label: "Diffusion SMS", legacy: "/app/diffusion-sms" },
    { key: "annonces", label: "Annonces", legacy: "/app/annonces" },
    { key: "modeles", label: "Modèles", legacy: "/app/comm-templates" },
    { key: "envoyes", label: "Courriels envoyés", legacy: "/app/courriels-envoyes" },
  ] },
  "/app/boutique": { title: "Boutique", desc: "Produits, Printful, cartes-cadeaux", tabs: [
    { key: "admin", label: "Boutique", legacy: "/app/boutique-admin" },
    { key: "printful", label: "Printful (POD)", legacy: "/app/printful" },
    { key: "produits", label: "Produits & pub", legacy: "/app/boutique-produits" },
    { key: "cartes", label: "Cartes-cadeaux", legacy: "/app/cartes-cadeaux" },
  ] },
  "/app/offres": { title: "Promos & offres", desc: "Promotions, codes promo et ROI", tabs: [
    { key: "promos", label: "Promos", legacy: "/app/promos" },
    { key: "codes", label: "Codes promo (ROI)", legacy: "/app/promos-kit" },
    { key: "radar", label: "Radar promotions", legacy: "/app/promotions" },
  ] },
  "/app/imports": { title: "Imports & migration", desc: "Contacts, Zen Planner, modifications en lot", tabs: [
    { key: "contacts", label: "Import contacts", legacy: "/app/contacts-bulk" },
    { key: "zenplanner", label: "Import Zen Planner", legacy: "/app/import-membres" },
    { key: "annules", label: "Clients annulés", legacy: "/app/migration-annules" },
    { key: "migration", label: "Migration Zen Planner", legacy: "/app/zp-migration" },
    { key: "bulk", label: "Bulk-edit élèves", legacy: "/app/bulk-edit-eleves" },
  ] },
  "/app/guides": { title: "Guides équipe", desc: "Aide-mémoire, guide coach, guide réception", tabs: [
    { key: "aide", label: "Guide & aide-mémoire", legacy: "/app/guide" },
    { key: "coach", label: "Guide Coach", legacy: "/app/guide-coach" },
    { key: "rencontre", label: "Résumé rencontre", legacy: "/app/rencontre-coachs" },
    { key: "reception", label: "Guide Réception", legacy: "/app/guide-reception" },
  ] },
};

// Pages retirées → page de remplacement.
export const RETIRED_REDIRECTS = {
  "/app/apercu": "/app",
  "/app/aujourdhui": "/app",
  "/app/morning-brief": "/app",
  "/app/mon-matin": "/app",
  "/app/centre-suivis": "/app/centre-suivi",
  "/app/mission": "/app/accueil-pilotage",
  "/app/trois-systemes": "/app/accueil-pilotage",
  "/app/cerveau-kaizen": "/app/accueil-pilotage",
  "/app/quick-cuts": "/app/accueil-pilotage",
  "/app/grille-kaizen-v2": "/app/grille-tarifaire",
  "/app/produits-catalogue": "/app/boutique",
  "/app/audit": "/app/audit-rentree",
  "/app/contrats": "/app/eleves",
  "/app/plans-cours-kmt": "/app/couverture-curriculum",
  "/app/jm-pointage": "/app/pointage",
};

export const LEGACY_REDIRECTS = {
  ...RETIRED_REDIRECTS,
  ...Object.fromEntries(Object.entries(HUB_META).flatMap(([hub, m]) => m.tabs.filter((t) => t.legacy && t.legacy !== "/app/guide-reception").map((t) => [t.legacy, `${hub}?tab=${t.key}`]))),
};

export const hubFor = (pathname) => HUB_META[pathname] || null;
